<!-- Modal backdrop -->
<div class="psrm-backdrop" *ngIf="visible" (click)="onBackdropClick($event)">
  <div class="psrm-dialog" role="dialog" aria-modal="true">

    <!-- Header -->
    <div class="psrm-header">
      <div class="psrm-status">
        <ng-container *ngIf="loading">
          <i class="fa fa-spinner fa-spin"></i>
          <span>Analysing&hellip;</span>
        </ng-container>
        <ng-container *ngIf="!loading && hasErrors">
          <i class="fa fa-exclamation-circle psrm-icon-error"></i>
          <span>Issues found &mdash; review before submitting</span>
        </ng-container>
        <ng-container *ngIf="!loading && !hasErrors && hasWarnings">
          <i class="fa fa-exclamation-triangle psrm-icon-warn"></i>
          <span>Review the warnings before submitting</span>
        </ng-container>
        <ng-container *ngIf="!loading && !hasErrors && !hasWarnings">
          <i class="fa fa-check-circle psrm-icon-ok"></i>
          <span>No issues found &mdash; ready to submit</span>
        </ng-container>
      </div>
      <button type="button" class="psrm-close" (click)="dismiss.emit()" title="Close">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- Loading spinner body -->
    <div class="psrm-body psrm-body-loading" *ngIf="loading">
      <i class="fa fa-spinner fa-spin fa-2x"></i>
      <span>Running AI review&hellip;</span>
    </div>

    <!-- Issues list -->
    <div class="psrm-body" *ngIf="!loading && issues.length > 0">
      <p class="psrm-hint" *ngIf="hasErrors || hasWarnings">
        <i class="fa fa-hand-o-right"></i>
        Click any item to jump directly to that field.
      </p>

      <div *ngFor="let issue of sortedIssues"
           class="psrm-issue"
           [class.psrm-issue-error]="issue.severity === 'error'"
           [class.psrm-issue-warn]="issue.severity === 'warning'"
           (click)="onIssueClick(issue)"
           [title]="'Go to ' + issue.label">

        <i class="fa"
           [class.fa-times-circle]="issue.severity === 'error'"
           [class.fa-exclamation-triangle]="issue.severity === 'warning'"></i>

        <div class="psrm-issue-body">
          <span class="psrm-issue-label">{{ issue.label }}</span>
          <span class="psrm-issue-text">{{ issue.issue }}</span>
          <span *ngIf="issue.canAutoFix && issue.suggestedFix" class="psrm-issue-hint">
            Suggested: <em>{{ issue.suggestedFix }}</em>
          </span>
        </div>

        <div class="psrm-issue-actions">
          <button type="button" *ngIf="issue.canAutoFix"
                  class="psrm-btn psrm-btn-fix"
                  (click)="$event.stopPropagation(); autoFix.emit(issue)">
            <i class="fa fa-magic"></i> Fix
          </button>
          <i class="fa fa-chevron-right psrm-goto-icon"></i>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="psrm-body psrm-body-ok" *ngIf="!loading && issues.length === 0">
      <i class="fa fa-check-circle fa-2x psrm-icon-ok"></i>
      <span>All checks passed — you&apos;re good to go!</span>
    </div>

    <!-- Footer -->
    <div class="psrm-footer">
      <!-- Re-check and Dismiss only shown while loading or when there are issues to act on -->
      <ng-container *ngIf="loading || hasErrors || hasWarnings">
        <button type="button" class="psrm-btn psrm-btn-ghost" (click)="recheck.emit()" [disabled]="loading">
          <i class="fa fa-refresh"></i> Re-check
        </button>
        <button type="button" class="psrm-btn psrm-btn-ghost" (click)="dismiss.emit()">Dismiss</button>
      </ng-container>

      <button type="button"
              *ngIf="canSubmit && hasWarnings && !hasErrors"
              class="psrm-btn psrm-btn-warn"
              (click)="submitAnyway.emit()">
        Continue with Submission
      </button>
      <!-- No manual Submit button for the no-issues case — auto-submit fires after 1.5s -->
    </div>

  </div>
</div>
